import { Buffer } from 'buffer';

// import { Readable } from 'stream';
import { MIN_PART_SIZE } from './constants';

// 异步生成器
export async function* getChunk(params: { file: File; chunkSize?: number }) {
  const { file, chunkSize = MIN_PART_SIZE } = params || {};
  const byteLength = file.size;
  let partNumber = 1;
  let startByte = 0;
  let endByte = chunkSize;

  while (endByte < byteLength) {
    yield {
      partNumber,
      data: file.slice(startByte, endByte),
    };
    partNumber += 1;
    startByte = endByte;
    endByte = startByte + chunkSize;
  }
  yield {
    partNumber,
    data: file.slice(startByte),
    lastPart: true,
  };
}

export async function* getChunkUint8Array(data: any, partSize = MIN_PART_SIZE) {
  let partNumber = 1;
  let startByte = 0;
  let endByte = partSize;
  while (endByte < data.byteLength) {
    yield {
      partNumber,
      data: data.subarray(startByte, endByte),
    };
    partNumber += 1;
    startByte = endByte;
    endByte = startByte + partSize;
  }
  yield {
    partNumber,
    data: data.subarray(startByte),
    lastPart: true,
  };
}

export async function* getChunkStream(
  data: any,
  partSize = MIN_PART_SIZE,
  getNextData: any,
) {
  let partNumber = 1;
  const currentBuffer: any = { chunks: [], length: 0 };
  for await (const datum of getNextData(data)) {
    currentBuffer.chunks.push(datum);
    currentBuffer.length += datum.byteLength;
    while (currentBuffer.length > partSize) {
      const dataChunk =
        currentBuffer.chunks.length > 1
          ? Buffer.concat(currentBuffer.chunks)
          : currentBuffer.chunks[0];
      yield {
        partNumber,
        data: dataChunk.subarray(0, partSize),
      };
      currentBuffer.chunks = [dataChunk.subarray(partSize)];
      currentBuffer.length = currentBuffer.chunks[0].byteLength;
      partNumber += 1;
    }
  }
  yield {
    partNumber,
    data:
      currentBuffer.chunks.length !== 1
        ? Buffer.concat(currentBuffer.chunks)
        : currentBuffer.chunks[0],
    lastPart: true,
  };
}

export async function* getDataReadable(data: any) {
  for await (const chunk of data) {
    if (Buffer.isBuffer(chunk) || chunk instanceof Uint8Array) {
      yield chunk;
    } else {
      yield Buffer.from(chunk);
    }
  }
}

export async function* getDataReadableStream(data: any) {
  const reader = data.getReader();
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        return;
      }
      if (Buffer.isBuffer(value) || value instanceof Uint8Array) {
        yield value;
      } else {
        yield Buffer.from(value);
      }
    }
  } catch (e) {
    throw e;
  } finally {
    reader.releaseLock();
  }
}

// export const getChunk = (data: any, partSize = MIN_PART_SIZE) => {
//   if (data instanceof Uint8Array) {
//     return getChunkUint8Array(data, partSize);
//   }
//   if (data instanceof Readable) {
//     return getChunkStream(data, partSize, getDataReadable);
//   }
//   if (data instanceof String || typeof data === 'string') {
//     return getChunkUint8Array(Buffer.from(data), partSize);
//   }
//   if (typeof data.stream === 'function') {
//     return getChunkStream(data.stream(), partSize, getDataReadableStream);
//   }
//   if (data instanceof ReadableStream) {
//     return getChunkStream(data, partSize, getDataReadableStream);
//   }
//   throw new Error(
//     'Body Data is unsupported format, expected data to be one of: string | Uint8Array | Buffer | Readable | ReadableStream | Blob;.',
//   );
// };
